import React from "react";
import "../../App.css";
import approachImg from "../../images/ApproachPage.jpg";

function Approach() {
  return (
    <>
      {/* Hero */}
      <section className="approach-hero" role="img" aria-label="Maryland—engineering projects">
        <div className="approach-hero__overlay" />
        <div className="approach-hero__content">
          <h1 className="approach-hero__title">Approach</h1>
          <p className="approach-hero__subtitle">
            Certified Minority Business Enterprise (MBE) delivering integrated A/E design & construction support since 1985
          </p>
        </div>
        <img src={approachImg} alt="" className="approach-hero__img" />
      </section>

      {/* Body */}
      <main className="approach-container">
        {/* Intro / Company Overview */}
        <section className="approach-section">
          <h2 className="approach-h2">Company Overview</h2>
          <div className="approach-card">
            <p>
              Dhillon Engineering, Inc. (DEI) is a Baltimore City-certified Minority Business Enterprise (MBE)
              specializing in multi-discipline architectural and engineering design services. Our areas of expertise
              include architecture, civil, structural, electrical, mechanical, and plumbing systems. In addition, we
              provide construction management, inspection, and a full range of construction support services.
            </p>
            <p>
              Our in-house, multidisciplinary team allows for seamless coordination across all phases of a project.
              This integrated approach enhances project efficiency and ensures consistent staff continuity—resulting in
              superior product quality and long-term client satisfaction. Since our founding in 1985, DEI has built a
              strong track record of success, reflected in numerous repeat contracts and work orders from valued clients.
            </p>
          </div>
        </section>

        {/* Design Overview */}
        <section className="approach-section">
          <h2 className="approach-h2">Design Overview</h2>
          <div className="approach-card">
            <p>
              DEI has delivered design services for a wide range of projects, including water and wastewater treatment
              facilities, new building construction, and building renovations. Notable examples include successful
              projects at the Back River and Patapsco Wastewater Treatment Plants, as well as various pumping stations
              and water treatment facilities. Recent work includes architectural,
              structural, mechanical, electrical, and plumbing design services.
            </p>
          </div>
        </section>

        {/* Services Grid */}
        <section className="approach-section">
          <h2 className="approach-h2">Mechanical & Electrical Services</h2>
          <div className="approach-grid">
            <div className="approach-card">
              <p>
                With over 40 years of experience in mechanical and electrical engineering, DEI offers a comprehensive
                suite of services:
              </p>
              <ul className="approach-list two-col">
                <li>HVAC design (heating, ventilation, air conditioning)</li>
                <li>Plumbing and fire protection systems</li>
                <li>Lighting and power distribution systems</li>
                <li>Building Automation Systems (BAS)</li>
              </ul>
            </div>
            <div className="approach-card">
              <p>
                Our portfolio spans water and wastewater facilities, pumping stations, commercial and institutional
                buildings, and residential developments. Electrical design capabilities include medium-voltage substation
                design and power distribution systems for filtration plants, treatment facilities, and other large-scale
                infrastructure projects.
              </p>
            </div>
          </div>
        </section>

        {/* Recent Projects */}
        <section className="approach-section">
          <h2 className="approach-h2">Recent Projects</h2>
          <div className="approach-grid">
            <div className="approach-card">
              <p>
                DEI recently completed architectural design for a new Screen Building at the Patapsco Wastewater
                Treatment Plant and renovation work at the Low Lift Pumping Station at the Ashburton Filtration Plant.
                Additional renovation designs include:
              </p>
              <ul className="approach-list">
                <li>The Engineering Office at Montebello Plant 2</li>
                <li>Control Rooms at Montebello Plants 1 and 2</li>
                <li>The Ashburton Filtration Plant</li>
              </ul>
              <p>
                <br></br>
                These projects included code-compliance enhancements (including ADA accessibility), space
                reconfigurations, interior finishes, and energy-efficient upgrades such as replacement of doors and
                windows.
              </p>
            </div>

            <div className="approach-card">
              <h3 className="approach-h3">Back River WWTP — Headworks Facilities</h3>
              <p>Structural design scope included:</p>
              <ul className="approach-list">
                <li>The Influent Pumping Station</li>
                <li>Fine Screen Building</li>
                <li>Grit Removal Facility</li>
              </ul>
              <p>
                <br></br>
                Deliverables covered pile and concrete cap design, shallow and mat foundations, and complex concrete
                substructures.
              </p>
            </div>
          </div>
        </section>

        {/* Structural Expertise */}
        <section className="approach-section">
          <h2 className="approach-h2">Structural Engineering Expertise</h2>
          <div className="approach-card">
            <ul className="approach-list two-col">
              <li>Heavy concrete structures</li>
              <li>Foundations and concrete decks</li>
              <li>Freshwater reservoirs</li>
              <li>Steel structures of various sizes and heights</li>
              <li>Upgrades for seismic and progressive collapse resistance</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default Approach;
